import React from 'react'
import { twMerge } from 'tailwind-merge'

import { Container } from './styles'

export default function Card({
    className, style = {}, disabled = false, id, expandOffset = 440, onContextMenu, onClick, children, ...props 
}) {
    return (
        <Container
            expandOffset={expandOffset}
            className={twMerge('bg-white', className)}
            style={style}
            disabled={disabled}
            id={id}
            onContextMenu={onContextMenu} 
            onClick={onClick}
            {...props}
        >
            {children}
        </Container>
    )
}
